<template>
  <b-modal id="show-material-requirements" ref="modal" :title="dialog_title" hide-footer>
    <div class="row">
      <div class="col-md-12">
        <table class="table table-search-results">
          <thead>
            <tr class="table-search-results__row">
              <th style="width:60%">MATERIAL</th>
              <th>UNIDADES</th>
              <th>COSTE</th>
              <th>ACCIONES</th>
            </tr>
          </thead>
          <tbody>
            <tr class="table-search-results__row" v-for="requirement, idx in requirements">
              <td style="width:60%">
                <provider-product-selector :id="'provider_product_selector_' + idx"
                  placeholder="Escribe para buscar el Material ..." v-model="requirement.provider_product_id">
                </provider-product-selector>
              </td>
              <td>
                <input class="form-control wabident-small" type="number" step="0.01"
                  v-model="requirement.stock_consumption">
              </td>
              <td>
                <input class="form-control wabident-small" type="number" step="0.01" v-model="requirement.custom_cost">
              </td>
              <td class="center">
                <button type="button" class="btn btn-wabident-round small" @click="deleteRequirement(idx)">
                  <i class="fas fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row form-group d-flex justify-content-around">
      <button type="button" :disabled="is_loading" @click="onAdd" class="btn btn-wabident green">Añadir</button>
      <button type="button" :disabled="is_loading" @click="onSubmit" class="btn btn-wabident">Guardar</button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ['product'],
  data() {
    return {
      requirements: [],
      is_loading: false,
    };
  },
  computed: {
    dialog_title() {
      return 'Requisitos de Tratamiento'
    },
    ...mapGetters(['clinic', 'errorwindow'])
  },
  methods: {
    show() {
      this.is_loading = false;
      this.loadRequirements();
      this.$refs.modal.show();
    },
    onAdd() {
      this.requirements.push({
        provider_product_id: null,
        stock_consumption: 1,
        custom_cost: null,
      });
    },
    onSubmit() {
      if (this.is_loading) {
        return;
      }

      const params = {
        requirements: this.requirements
      };

      this.is_loading = true;
      axios.post(`/product/${this.product.id}/requirements`, params).then((resp) => {
        this.$refs.modal.hide();
      }).catch(() => {
        this.errorwindow.show('Error', 'Error cargando Requisitos. Por favor consulte al Administrador');
      }).then(() => {
        this.is_loading = false;
      });
    },
    deleteRequirement(idx) {
      this.requirements.splice(idx, 1);
    },
    loadRequirements() {
      axios.get(`/product/${this.product.id}/requirements`).then((resp) => {
        this.requirements = resp.data;
      }).catch(() => {
        this.errorwindow.show('Error', 'Error cargando Requisitos. Por favor consulte al Administrador');
      });
    }
  }
}
</script>

<style lang="scss">
#show-material-requirements {
  .modal-dialog {
    max-width: 960px;
  }
}
</style>
